import src from "IMAGE";
export default { src, width: 1305, height: 1150, blurWidth: 0, blurHeight: 0};
